import Plus from "app/smartphone/[slug]/[reference]/SuppliedAccessoriesSection/plus.svg";
import { StrapiImage, StrapiImageData } from "ui/StrapiImage";

type AccessoryCardProps = { name?: string; image?: StrapiImageData };

export const AccessoryCard = ({ image, name }: AccessoryCardProps) => (
  <>
    <div className="flex flex-col gap-2 items-center">
      <p className="font-semibold text-center lg:hidden">{name}</p>
      <StrapiImage
        size="thumbnail"
        image={image}
        className="min-w-[6rem] min-h-[6rem]"
        sizes="(max-width: 1024px) 50vw, 33vw"
      />
      <p className="hidden font-semibold lg:block">{name}</p>
    </div>
    <Plus className="hidden lg:block lg:last:hidden" />
  </>
);
